import Pagination from '@/util/pagination'

export default function () {
  return {
    contents: [],
    pagination: new Pagination(),
    showDeleteDialog: false,
    deletingId: null,
  }
}
